import { useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import K from '../services/k'
import $ from 'jquery'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import Base64 from 'crypto-js/enc-base64'
import { HmacSHA256 } from 'crypto-js'
import { Form, Modal } from 'react-bootstrap'
import DatePicker from 'react-multi-date-picker'
import Services from '../services/Services'

function Checkout(props) {
  Date.isLeapYear = function (year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  }

  Date.getDaysInMonth = function (year, month) {
    return [
      31,
      Date.isLeapYear(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ][month]
  }

  Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear())
  }

  Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth())
  }

  Date.prototype.addMonths = function (value) {
    var n = this.getDate()
    this.setDate(1)
    this.setMonth(this.getMonth() + value)
    this.setDate(Math.min(n, this.getDaysInMonth()))
    return this
  }

  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const token = localStorage.getItem(['__react_session__'])
  const jsontoken = JSON.parse(token)
  const [orderMembership, setOrderMembership] = useState({})

  if (!jsontoken || !jsontoken.api_token) {
    props.logOut()
  }
  const history = useHistory()

  const [currentUser, setCurrentUser] = useState({})
  const [deliveryFee, setDeliveryFee] = useState(0)
  const [maintenanceFee, setMaintenanceFee] = useState(0)

  const [restaurantId, setrestaurantId] = useState('')
  const [address, setaddress] = useState('')
  const [latLng, setLatLng] = useState(null)
  const [addressDescription, setAddressDescription] = useState('')
  const [mealprep_date, setmealprep_date] = useState([])
  const [delivery_date, setdelivery_date] = useState('')
  const [delivery_now, setdelivery_now] = useState(true)
  const [validDeliveryDate, setvalidDeliveryDate] = useState(false)

  const handleDescriptionChange = (e) => {
    setAddressDescription(e.target.value)
  }

  const handleChange = (address) => {
    setaddress(address)
    setLatLng(null)
  }

  // Production
  const payment_url = 'https://www2.ipg-online.com/connect/gateway/processing'
  const sharedSecret = 'M8weY>2^Nz'
  const storeId = '7439468100011'

  const separator = '|'
  const timezone = 'America/New_York'
  const txntype = 'sale'
  const currency = '388'
  const checkoutoption = 'combinedpage'
  const hash_algorithm = 'HMACSHA256'

  const paymentMethod = 'M'
  const language = 'en_US'
  const mode = 'payonly'

  const responseSuccessURL = `${K.baseUrl}checkout/ipg/response?success=1&client_id=${jsontoken.user_id}&apiToken=${jsontoken.api_token}`
  const responseFailURL = `${K.baseUrl}checkout/ipg/response?success=0&client_id=${jsontoken.user_id}&apiToken=${jsontoken.api_token}`

  function convertTZ(date, tzString) {
    return new Date(
      (typeof date === 'string' ? new Date(date) : date).toLocaleString(
        'en-US',
        { timeZone: tzString },
      ),
    )
  }
  function getDate() {
    var t = new Date()
    t = convertTZ(t, timezone)
    const date = ('0' + t.getDate()).slice(-2)
    const month = ('0' + (t.getMonth() + 1)).slice(-2)
    const year = t.getFullYear()
    const hours = ('0' + t.getHours()).slice(-2)
    const minutes = ('0' + t.getMinutes()).slice(-2)
    const seconds = ('0' + t.getSeconds()).slice(-2)
    const time = `${year}:${month}:${date}-${hours}:${minutes}:${seconds}`
    return time
  }
  const [payHash, setPayHash] = useState('')
  const [showPayModal, setShowPayModal] = useState(false)
  const [txndatetime, settxndatetime] = useState(getDate())
  const clickShowPayModal = () => {
    var current_time = getDate()
    settxndatetime(current_time)

    // AlphaBeta key order params
    var stringToExtendedHash =
      totalBilledAmount.toFixed(2) +
      separator +
      checkoutoption +
      separator +
      'RestaurantID:' +
      restaurantId +
      separator + // comments
      currency +
      separator +
      jsontoken.user_id +
      separator + // customerid
      hash_algorithm +
      separator +
      language +
      separator +
      mode +
      separator +
      // + paymentMethod + separator
      responseFailURL +
      separator +
      responseSuccessURL +
      separator +
      storeId +
      separator +
      timezone +
      separator +
      current_time +
      separator + // txndatetime
      txntype

    var hashHMACSHA256 = HmacSHA256(stringToExtendedHash, sharedSecret)
    var hash = Base64.stringify(hashHMACSHA256)
    setPayHash(hash)

    setShowPayModal(true)
  }

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setaddress(address)
        setLatLng(latLng)
      })
      .catch((error) => console.error('Error', error))
  }

  //const coordinates
  const [restdata, setrestdata] = useState({})
  const fetchrest = async () => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}restaurant/${restaurantId}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    setrestdata(resp.data.data['restaurant'][0])
  }
  const [membership, setmembership] = useState([])
  const [availableMemberships, setAvailableMemberships] = useState([])
  const [service_fee, setservicefee] = useState(0)
  const [distance_service_fee, setdistanceservicefee] = useState(0)
  const [tax, settax] = useState(0)
  //fetch cart
  const [cart, setcart] = useState([])

  const [readytime, setreadytime] = useState(0)

  const [hasPrepMeal, setHasPrepMeal] = useState(false)
  const [mealPrepDays, setmealPrepDays] = useState(1)
  //fetch total
  const [carttotal, setcarttotal] = useState(0)
  const [order, setOrder] = useState(0)

  function MyPlugin() {
    return 'Select ' + mealPrepDays + ' days only!'
  }

  useEffect(() => {
    fetchcart()
    fetchaddresses(jsontoken.user_id)
  }, [])

  useEffect(() => {
    if (orderMembership && orderMembership.id) {
      try {
        setservicefee(parseInt(orderMembership.service_fee))
      } catch (error) {
        if (
          membership &&
          membership.id !== undefined &&
          membership.enable === '1'
        ) {
          setservicefee(Number(membership.service_fee))
        }
      }
    } else {
      if (
        membership &&
        membership.id !== undefined &&
        membership.enable === '1'
      ) {
        setservicefee(Number(membership.service_fee))
      }
    }
  }, [orderMembership, membership])

  const fetchcart = async () => {
    if (
      jsontoken !== null &&
      jsontoken.api_token &&
      jsontoken.api_token !== null &&
      jsontoken.api_token !== ''
    ) {
      const data = {
        apiToken: jsontoken.api_token,
        client_id: jsontoken.user_id,
      }
      var resp
      try {
        resp = await Axios.post(`${K.baseUrl}cart`, data)
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message &&
          error.response.data.message.indexOf('log in') > -1
        ) {
          props.logOut()
          return
        }
      }
      if (resp && resp.message && resp.message.indexOf('log in') > -1) {
        props.logOut()
        return
      }
      if (resp.data.resultcode === 1) {
        setcart(resp.data.cartitems)
        var readyTime = 0
        resp.data.cartitems.every((element) => {
          if (readyTime < element.wtime) {
            readyTime = parseInt(element.wtime)
          }
          if (element.type === 'meal_prep') {
            setHasPrepMeal(true)
            setmealPrepDays(element.meal_prep_days)
            return false
          }
          return true
        })
        setreadytime(readyTime)
        setcarttotal(resp.data.order[0].total)
        setOrder(resp.data.order[0])
        setrestaurantId(resp.data.order[0]['restaurant_id'])
      } else {
        setcart([])
        setreadytime(0)
      }

      const mem = await Axios.post(
        `${K.baseUrl}membership/` + jsontoken.user_id,
        data,
      )
      if (mem && mem.message && mem.message.indexOf('log in') > -1) {
        props.logOut()
        return
      }
      let memberships = []
      let myMembership = mem.data.data
      setmembership(myMembership)
      if (mem.data.memberships && mem.data.memberships.length > 0) {
        mem.data.memberships.map((item) => {
          if (myMembership && item.price > 0 && myMembership.id !== item.id) {
            memberships.push(item)
          }
        })
      }
      setAvailableMemberships(memberships)
      if (
        myMembership &&
        myMembership.id !== undefined &&
        myMembership.enable === '1'
      ) {
        setservicefee(Number(myMembership.service_fee))
      }
    } else {
      props.logOut()
    }
  }

  const [useraddresses, setstateuseraddresses] = useState([])
  const [selectedAddress, setSelectedAddress] = useState({})
  const fetchaddresses = async (userid) => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/addresses/${userid}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp.data.resultcode === 1) {
      setstateuseraddresses(resp.data.addresses)
    }
  }

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180)
  }

  useEffect(
    function () {
      if (restaurantId) {
        fetchrest()
      }
    },
    [restaurantId],
  )

  var rlatitude, rlongitude, clatitude, clongitude
  const [finaldistance, setfinaldistance] = useState('')
  const [dtime, setdtime] = useState(0)
  const [distance_variable, setdistance_variable] = useState(0)

  useEffect(() => {
    const services = new Services(this)
    services.fetchUser().then((data) => {
      if (data.resultcode === 1) {
        const user = data.user[0]
        setCurrentUser(user)
      }
    })
  }, [])

  useEffect(() => {
    rlatitude = restdata.latitude
    rlongitude = restdata.longitude
    clatitude = 0
    clongitude = 0

    if (selectedAddress.id !== null) {
      clatitude = selectedAddress.address_latitude
      clongitude = selectedAddress.address_longitude
    }

    const distance = new Services().getDistanceFromLatLonInKm(
      rlatitude,
      rlongitude,
      clatitude,
      clongitude,
    )

    Axios.post(`${K.baseUrl}checkout/delivery/summary`, {
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      distance: Math.round(distance),
      lat1: rlatitude,
      lng1: rlongitude,
      lat2: clatitude,
      lng2: clongitude,
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        setDeliveryFee(res.data.delivery_fee ? res.data.delivery_fee : 0)
        setMaintenanceFee(res.data.maintenance_fee)
        var distanceVariable = res.data.distance_variable
          ? res.data.distance_variable
          : 0
        setdistance_variable(distanceVariable)

        var duration = res.data.duration ? res.data.duration : 0
        var distance = res.data.distance ? res.data.distance : 0
        if (duration === 15001 && distance === 15001) {
          setvalidDeliveryDate(false)
          setdtime(0)
          setfinaldistance('NAN ' + 'KM')
        } else {
          setdtime((Math.round(duration) / 60).toFixed(1))
          setfinaldistance((distance / 1000).toFixed(1) + 'KM')
          isValidDeliveryDates()
        }
      })
      .catch((error) => {})
  }, [selectedAddress, restdata, service_fee])

  useEffect(() => {
    setdistanceservicefee(
      service_fee + Math.round((service_fee * distance_variable) / 100),
    )
  }, [distance_variable, service_fee])

  useEffect(() => {
    var amount = carttotal
    var commission = restdata.dfee
    var commission_fee =
      (((amount * (100 - restdata.discount)) / 100) * commission) / 100

    var transaction = restdata.transaction_fee
    var transaction_fee =
      (((amount * (100 - restdata.discount)) / 100) * transaction) / 100

    var maintenance_fee = deliveryFee * (parseInt(maintenanceFee + '') / 100)
    var hosting_fee = restdata.hosting_fee
    settax(
      Math.round(
        (commission_fee +
          transaction_fee +
          maintenance_fee +
          distance_service_fee +
          hosting_fee) *
          0.15,
      ),
    )
  }, [distance_service_fee, deliveryFee, carttotal, restdata, maintenanceFee])

  const [instruction, setInstruction] = useState('')
  const [coupon, setCoupon] = useState('')
  const [tipAmount, tipDriver] = useState(0)

  const onAddressSubmit = () => {
    Axios.post(`${K.baseUrl}users/address_processing`, {
      action: 'add_address',
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      address: address,
      lat: latLng.lat ?? 0,
      lng: latLng.lng ?? 0,
      description: addressDescription,
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        if (res.data.resultcode) {
          window.location.reload()
        }
      })
      .catch((error) => {})
  }

  const onSelectAddress = (e) => {
    var address_id = e.currentTarget.dataset.address_id
    var index = e.currentTarget.dataset.index
    setSelectedAddress(useraddresses[index])
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  const onAddressRemove = (e) => {
    var address_id = e.currentTarget.dataset.address_id
    Axios.post(`${K.baseUrl}users/address_processing`, {
      action: 'remove_address',
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      address_id: address_id,
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        if (res.data.resultcode) {
          window.location.reload()
        }
      })
      .catch((error) => {})
  }

  const initPaymentProcessByBalance = () => {
    let mealprep_date_str = []
    mealprep_date.forEach((element) => {
      mealprep_date_str.push(
        element.year + '-' + element.month.number + '-' + element.day,
      )
    })
    Axios.post(`${K.baseUrl}checkout`, {
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      distance: finaldistance.replace('KM', ''),
      dtime: parseFloat(dtime),
      rlat: restdata.latitude ?? 0,
      rlon: restdata.longitude ?? 0,
      address_id: selectedAddress.id,
      address_name: selectedAddress.address_name,
      lat: selectedAddress.address_latitude,
      lon: selectedAddress.address_longitude,
      instruction: selectedAddress.address_description,
      coupon: coupon,
      tip: tipAmount,
      order_membership:
        orderMembership && orderMembership.id ? orderMembership.id : -1,
      prep_time: hasPrepMeal
        ? mealprep_date_str
        : delivery_date
        ? [delivery_date]
        : [],
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        if (res.data.complete) {
          window.location.href = res.data.link
        } else {
          window.location.reload()
        }
      })
      .catch((error) => {})
  }

  const initPaymentProcess = () => {
    let w = 800,
      h = 600
    const y = window.top.outerHeight / 2 + window.top.screenY - h / 2
    const x = window.top.outerWidth / 2 + window.top.screenX - w / 2
    let popupWin = window.open(
      'about:blank',
      'Payment',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`,
    )
    let html = `<style>.loader,.loader:after{border-radius:50%;width:10em;height:10em}.loader{margin:60px auto;font-size:10px;position:relative;text-indent:-9999em;border-top:1.1em solid rgba(66,183,73,.2);border-right:1.1em solid rgba(66,183,73,.2);border-bottom:1.1em solid rgba(66,183,73,.2);border-left:1.1em solid #42b749;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear}@-webkit-keyframes load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}</style>
<div className="loader">Loading...</div>`
    popupWin.document.write(html)

    $('#place-order-btn').attr('disabled', true)
    $('#order-process').removeClass('d-none')

    let timer = setInterval(() => {
      if (popupWin.closed) {
        clearInterval(timer)
        Axios.post(`${K.baseUrl}checkout/order/status`, {
          apiToken: jsontoken.api_token,
          client_id: jsontoken.user_id,
          order: order.id,
        })
          .then((res) => {
            if (res && res.message && res.message.indexOf('log in') > -1) {
              props.logOut()
              return
            }
            if (res.data.order) window.location.href = res.data.link
          })
          .finally(() => {
            $('#place-order-btn').attr('disabled', false)
            $('#order-process').addClass('d-none')
          })
      }
    }, 500)

    Axios.post(`${K.baseUrl}checkout`, {
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      distance: finaldistance.replace('KM', ''),
      dtime: parseFloat(dtime),
      rlat: restdata.latitude ?? 0,
      rlon: restdata.longitude ?? 0,
      address_id: selectedAddress.id,
      address_name: selectedAddress.address_name,
      lat: selectedAddress.address_latitude,
      lon: selectedAddress.address_longitude,
      instruction: selectedAddress.address_description,
      coupon: coupon,
      tip: tipAmount,
      user_address: jsontoken.address,
      discount: restdata.discount,
      pay_method: 'IPN',
      order_membership:
        orderMembership && orderMembership.id ? orderMembership.id : -1,
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        if (res.data.redirect) {
          popupWin.location.href = res.data.redirect
        } else if (res.data.complete) {
          popupWin.close()
          clearInterval(timer)
          window.location.href = res.data.link
        }
      })
      .catch((error) => {
        clearInterval(timer)
        let html =
          '<h2>Oops! Something went wrong</h2><h3>Close the window and try again</h3>'
        popupWin.document.write(html)
      })
  }

  const [couponAmount, setCouponAmount] = useState(0)

  const applyMembership = (selectedMembership) => {
    setOrderMembership(selectedMembership)
  }

  const applyCoupon = () => {
    $('#apply_btn').html('<i className="fa fa-spinner fa-spin"></i>')
    $('#apply_btn').attr('disable', true)

    Axios.post(`${K.baseUrl}checkout/coupon`, {
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      restaurant_id: restaurantId,
      coupon: coupon,
    })
      .then((res) => {
        if (res && res.message && res.message.indexOf('log in') > -1) {
          props.logOut()
          return
        }
        setCouponAmount(res.data.amount)
        if (res.data.amount > 0) {
          $('#promo-success').removeClass('d-none')
          $('#invalid-code').addClass('d-none')
        } else {
          $('#promo-success').addClass('d-none')
          $('#invalid-code').removeClass('d-none')
        }
      })
      .catch((error) => {
        $('#invalid-code').removeClass('d-none')
        $('#invalid-code').html('Something went wrong, try again')
      })
      .finally(() => {
        $('#apply_btn').html('apply')
        $('#apply_btn').attr('disable', false)
      })
  }

  const [totalBilledAmount, setTotalBilledAmount] = useState(0)

  useEffect(() => {
    try {
      var amt =
        (Number(carttotal) * (100 - Number(restdata.discount))) / 100 +
        deliveryFee +
        Number(tipAmount) +
        distance_service_fee +
        restdata.hosting_fee +
        tax -
        Number(couponAmount)
      amt = Math.round(amt)
      if (orderMembership && orderMembership.id) {
        setTotalBilledAmount((amt > 0 ? amt : 0) + orderMembership.price)
      } else {
        setTotalBilledAmount(amt > 0 ? amt : 0)
      }
    } catch (error) {
      console.log(error)
    }
  }, [
    carttotal,
    restdata,
    deliveryFee,
    tipAmount,
    distance_service_fee,
    tax,
    couponAmount,
    orderMembership,
    service_fee,
  ])

  const removecart = async (id) => {
    const data = {
      apiToken: jsontoken.api_token,
      client_id: jsontoken.user_id,
      item_id: id,
    }
    var resp
    try {
      resp = await Axios.post(`${K.baseUrl}deletecart`, data)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    fetchcart()
  }

  let search_options = {
    // location: new window.google.maps.LatLng(18.466667, -77.916667),
    // radius: 20000,
    componentRestrictions: { country: ['jm'] },
    // types: ["address", "regions"],    // address, (cities), (regions) ...
  }

  const handlePaySubmit = async (e) => {
    let mealprep_date_str = []
    mealprep_date.forEach((element) => {
      mealprep_date_str.push(
        element.year + '-' + element.month.number + '-' + element.day,
      )
    })
    $('#new-place-order-btn').attr('disabled', true)
    $('#order-process').removeClass('d-none')
    try {
      var resp = await Axios.post(`${K.baseUrl}checkout/ipg/request`, {
        apiToken: jsontoken.api_token,
        client_id: jsontoken.user_id,
        distance: finaldistance.replace('KM', ''),
        dtime: parseFloat(dtime),
        rlat: restdata.latitude ?? 0,
        rlon: restdata.longitude ?? 0,
        address_id: selectedAddress.id,
        address_name: selectedAddress.address_name,
        lat: selectedAddress.address_latitude,
        lon: selectedAddress.address_longitude,
        instruction: selectedAddress.address_description,
        coupon: coupon,
        tip: tipAmount,
        user_address: jsontoken.address,
        discount: restdata.discount,
        pay_method: 'IPG',
        order_membership:
          orderMembership && orderMembership.id ? orderMembership.id : -1,
        prep_time: hasPrepMeal
          ? mealprep_date_str
          : delivery_date
          ? [delivery_date]
          : [],
      })
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    $('#new-place-order-btn').attr('disabled', false)
    $('#order-process').addClass('d-none')
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp && resp.data && resp.data.success === 1) {
      $('#new-place-order-btn').attr('disabled', true)
      $('#order-process').removeClass('d-none')
      document.getElementById('payment_form').submit()
      return
    }
    return
  }

  const handleDateChange = (event) => {
    if (event.target.name.indexOf('mealprep_date') > -1) {
      setmealprep_date(event.target.value)
    } else if (event.target.name === 'delivery_date') {
      setdelivery_date(event.target.value)
    } else if (event.target.name === 'delivery_now') {
      setdelivery_now(event.target.checked)
      if (event.target.checked) {
        setdelivery_date('')
      }
    }
    isValidDeliveryDates()
  }

  const isValidDeliveryDates = () => {
    let isValid = true
    if (hasPrepMeal) {
      cart.forEach((element) => {
        if (element.type === 'meal_prep') {
          isValid = mealprep_date.length === mealPrepDays
        }
      })
    } else {
      isValid = delivery_now || (!delivery_now && delivery_date)
    }
    setvalidDeliveryDate(isValid)
  }

  useEffect(() => {
    isValidDeliveryDates()
  }, [cart, hasPrepMeal, mealprep_date, delivery_now, delivery_date])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section className="checkout-sec">
          <div className="container">
            <Modal
              show={true}
              keyboard={false}
              className={
                theme && theme === 'DARK'
                  ? 'modal_confirm_order_dark'
                  : 'modal_confirm_order_light'
              }
            >
              <Modal.Header closeButton>
                <h4 className="modal-title">Confirm Order</h4>
              </Modal.Header>
              <Modal.Body>
                <div className="modal-body">
                  Please install the mobile application in order to proceed with
                  your order.
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="modal-footer">
                  <a
                    href="https://apps.apple.com/us/app/road-jockey/id1595594217?platform=iphone"
                    className="ml-4"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="m-0"
                      src="https://roadjockey.com/images/img-apple-btn.png"
                      style={{ height: '35px' }}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/search?q=road%20jockey%20llc&c=apps"
                    className="ml-4"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="m-0"
                      src="https://roadjockey.com/images/img-google-btn.png"
                      style={{ height: '35px' }}
                    />
                  </a>
                </div>
              </Modal.Footer>
            </Modal>
            <div className="row d-none">
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="order-summary">
                  <div className="heading-text border-bottom">
                    <h3 className="mt-4">{restdata.rname}</h3>
                    <h5 className="mt-4">{restdata.instructions}</h5>
                    <p className="mt-4">
                      {cart.length} products from {restdata.rname}
                    </p>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-12 p-0 mt-3">
                      {selectedAddress.id !== null ? (
                        <div className="alert alert-success">
                          <strong className="mr-3">Delivery Address:</strong>{' '}
                          {selectedAddress.address_name}
                        </div>
                      ) : (
                        <div className="alert alert-warning">
                          <strong>Delivery Address: </strong> Please choose an
                          address from the address book!
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-12 p-0 mt-3">
                      <h4 className="d-inline-block">Your Address Book</h4>
                      <button
                        type="button"
                        className="btn btn-success"
                        data-toggle="collapse"
                        data-target="#demo"
                        style={{ float: 'right' }}
                      >
                        Add Address
                      </button>
                    </div>
                    <div
                      id="demo"
                      className="collapse col-12 card"
                      style={{ border: '1px solid rgba(0, 0, 0, 0.125)' }}
                    >
                      <div className="order-form_ card-body">
                        <div className="form-group">
                          <span>Delivery Address</span>
                          <PlacesAutocomplete
                            value={address}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            searchOptions={search_options}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: 'Search Places ...',
                                    className: 'location-search-input',
                                  })}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion, index) => {
                                    const className = suggestion.active
                                      ? 'suggestion-item--active'
                                      : 'suggestion-item'
                                    const style = { cursor: 'pointer' }
                                    return (
                                      <div
                                        key={index}
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                        <div className="form-group">
                          <span>Delivery Instructions</span>
                          <input
                            name="address_description"
                            placeholder="Delivery Details"
                            onChange={handleDescriptionChange}
                          />
                        </div>
                        {latLng === null ? (
                          <button
                            type="button"
                            className="btn btn-success"
                            disabled="disabled"
                          >
                            Submit
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={onAddressSubmit}
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    </div>
                    <table className="table table_custom mt-2">
                      <thead className="bg-success" style={{ color: 'white' }}>
                        <tr>
                          <th>No</th>
                          <th>Address</th>
                          <th>Description</th>
                          <th style={{ minWidth: '130px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {useraddresses
                          ? useraddresses.map((address, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{address.address_name}</td>
                                <td>{address.address_description}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-success"
                                    data-address_id={address.id}
                                    data-index={index}
                                    onClick={onSelectAddress}
                                  >
                                    Select
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger ml-2"
                                    data-address_id={address.id}
                                    onClick={onAddressRemove}
                                  >
                                    <i className="text-success__">
                                      <FontAwesomeIcon icon={faTrash} />
                                    </i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          : ''}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                {cart.length < 1 ? (
                  <div className="your-order-card">
                    <div className="card-head">
                      <h5>No items in cart</h5>
                    </div>
                  </div>
                ) : (
                  <div className="your-order-card mb-5">
                    <div
                      id="carouselExampleControls"
                      className="carousel slide mt-5 mb-5"
                      data-ride="carousel"
                    >
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <img
                            className="d-block w-100"
                            src="images/Store.png"
                            alt="Second slide"
                          />
                        </div>
                        <div className="carousel-item">
                          <img
                            className="d-block w-100"
                            src="images/Scooter.png"
                            alt="Third slide"
                          />
                        </div>
                      </div>

                      <a
                        className="carousel-control-prev"
                        href="#carouselExampleControls"
                        role="button"
                        data-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="carousel-control-next"
                        href="#carouselExampleControls"
                        role="button"
                        data-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>

                    <div className="card-head">
                      <h4 className={'text-center mb-3'}>Your Order</h4>
                      <h4 className={'text-success mb-2'}>{restdata.rname} </h4>
                    </div>

                    <div className="order-listing">
                      <ul>
                        {cart
                          ? cart.map((cartitem, index) => (
                              <li key={index}>
                                <p>
                                  <span style={{ width: 100 }}>
                                    {cartitem.quantity}x
                                  </span>{' '}
                                  {cartitem.meal_name}
                                </p>
                                <p>
                                  <span style={{ width: 100 }}>JMD</span>
                                  <b>
                                    ${cartitem.price * cartitem.meal_prep_days}
                                  </b>
                                </p>
                                {cartitem.flavour !== '' &&
                                  cartitem.flavour !== 'No Option' && (
                                    <p>
                                      <span style={{ width: 100 }}>Option</span>{' '}
                                      <b>{cartitem.flavour}</b>
                                    </p>
                                  )}
                                <p>
                                  <span style={{ width: 100 }}>Size</span>{' '}
                                  <b>{cartitem.size}</b>
                                </p>
                                {cart.length > 1 ? (
                                  <button
                                    onClick={removecart.bind(this, cartitem.id)}
                                  >
                                    Remove
                                  </button>
                                ) : (
                                  ''
                                )}
                                <br />
                                <br />
                              </li>
                            ))
                          : ''}
                      </ul>

                      {availableMemberships &&
                      availableMemberships.length > 0 ? (
                        <ul>
                          {availableMemberships.map((item) => {
                            return (
                              <li key={item.id}>
                                <p>{item.description}</p>
                                <p>
                                  Price:{' '}
                                  <b>JMD ${item.price * item.meal_prep_days}</b>
                                </p>
                                {orderMembership &&
                                orderMembership.id === item.id ? (
                                  <button
                                    id={'apply_membership'}
                                    className="btn btn-sm btn-danger"
                                    onClick={() => {
                                      applyMembership({})
                                    }}
                                  >
                                    Remove From Cart
                                  </button>
                                ) : (
                                  <button
                                    id={'apply_membership'}
                                    className="btn btn-sm btn-success"
                                    onClick={() => {
                                      applyMembership(item)
                                    }}
                                  >
                                    Add to Cart
                                  </button>
                                )}
                              </li>
                            )
                          })}
                        </ul>
                      ) : (
                        <div></div>
                      )}

                      {cart && restdata.discount > 0 ? (
                        <ul>
                          <li>
                            <p>
                              Discount: <b>{restdata.discount}</b>%
                            </p>
                          </li>
                        </ul>
                      ) : (
                        ''
                      )}

                      {!hasPrepMeal && (
                        <div>
                          <Form.Check
                            type="checkbox"
                            name="delivery_now"
                            onChange={handleDateChange}
                            defaultChecked={true}
                            label="Deliver Now"
                          />
                          {!delivery_now && (
                            <div className="mt-2">
                              <label>Delivery Time</label>
                              <Form.Control
                                type="datetime-local"
                                name="delivery_date"
                                onChange={handleDateChange}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {hasPrepMeal && (
                        <div>
                          <p>Select Prep Days({mealPrepDays})</p>
                          <DatePicker
                            multiple
                            sort
                            plugins={[
                              <MyPlugin key="my-plugin" position="bottom" />,
                            ]}
                            minDate={new Date()}
                            maxDate={new Date().addMonths(1)}
                            value={mealprep_date}
                            onChange={setmealprep_date}
                          />
                        </div>
                      )}

                      <div className="row m-0 ml-1 mt-5">
                        <label className="text-muted">Apply coupon</label>
                        <div className="col-9 p-0">
                          <input
                            type="text"
                            placeholder="Promo code"
                            className="p-1"
                            style={{ width: '100%' }}
                            onChange={(event) => setCoupon(event.target.value)}
                          />
                        </div>
                        <div className="col-3 p-0">
                          <button
                            id={'apply_btn'}
                            className="btn btn-sm btn-success"
                            onClick={applyCoupon}
                            style={{ width: '100%' }}
                          >
                            apply
                          </button>
                        </div>

                        <div className="col-12">
                          <div
                            id={'promo-success'}
                            className={
                              'alert alert-success text-sm-center mt-1 p-0 ' +
                              (Number(couponAmount) > 0 ? '' : 'd-none')
                            }
                          >
                            Promo discount: <strong>${couponAmount}</strong>
                          </div>
                          <div
                            id={'invalid-code'}
                            className="alert alert-danger alert-dismissible d-none mt-1 p-0"
                          >
                            <a
                              href="#"
                              className="close p-0"
                              data-dismiss="alert"
                              aria-label="close"
                            >
                              &times;
                            </a>
                            The promo code is invalid or your order total is
                            less than JMD 2000.
                          </div>
                          <hr />
                        </div>

                        <div className="col-12 p-0">
                          <label className="text-muted d-inline">
                            Tip Rider:{' '}
                          </label>
                          <input
                            type="number"
                            placeholder="amount"
                            className="p-1 text-center d-inline"
                            style={{ width: 'auto', maxWidth: '100px' }}
                            min="0"
                            step="10"
                            onChange={(event) => tipDriver(event.target.value)}
                          />
                        </div>
                      </div>
                      <hr />

                      <div className="p-3">
                        <table style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <td>
                                <span>Distance:</span>
                              </td>
                              <td>
                                <b>{finaldistance}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>Estimated Time:</span>
                              </td>
                              <td>
                                <b>
                                  {parseFloat(dtime) + parseFloat(readytime)}{' '}
                                  mins
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>Delivery Fee:</span>
                              </td>
                              <td>
                                <b>
                                  JMD $
                                  {deliveryFee >= 0 ? deliveryFee : 'Unkown'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>Service Fee:</span>
                              </td>
                              <td>
                                <b>JMD ${distance_service_fee}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>Hosting Fee:</span>
                              </td>
                              <td>
                                <b>JMD ${restdata.hosting_fee}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>Tax:</span>
                              </td>
                              <td>
                                <b>JMD ${tax}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>
                                <span>Account Balance:</span>
                              </td>
                              <td>
                                <b>
                                  JMD $
                                  {currentUser &&
                                  currentUser.personal_balance > 0
                                    ? currentUser.personal_balance
                                    : 0}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {selectedAddress.id === null ||
                        selectedAddress.id === undefined ? (
                          <div className="alert alert-danger">
                            Please choose a delivery address
                          </div>
                        ) : parseFloat(finaldistance.replace('KM', '')) <= 15 &&
                          validDeliveryDate ? (
                          <div>
                            <button
                              type="button"
                              className="btn primary-btn"
                              onClick={clickShowPayModal}
                            >
                              <span>Confirm Order</span>
                            </button>
                            {/* <Modal
                              show={showPayModal}
                              onHide={() => {
                                setShowPayModal(false)
                              }}
                              keyboard={false}
                              className={
                                theme && theme === 'DARK'
                                  ? 'modal_confirm_order_dark'
                                  : 'modal_confirm_order_light'
                              }
                            >
                              <Modal.Header closeButton>
                                <h4 className="modal-title">Confirm Order</h4>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="modal-body">
                                  Are you sure confirm this order?
                                </div>
                                <i
                                  id={'order-process'}
                                  className={
                                    'fa fa-spinner fa-spin fa-fw text-success d-none'
                                  }
                                />
                              </Modal.Body>
                              <Modal.Footer>
                                <div className="modal-footer">
                                  {totalBilledAmount >
                                  (currentUser &&
                                  currentUser.personal_balance > 0
                                    ? currentUser.personal_balance
                                    : 0) ? (
                                    <div className="d-inline-block">
                                      <form
                                        id="payment_form"
                                        method="post"
                                        className="d-none__"
                                        action={payment_url}
                                      >
                                        <fieldset>
                                          <input
                                            type="hidden"
                                            name="storename"
                                            value={storeId}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="timezone"
                                            value={timezone}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="txntype"
                                            value={txntype}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="chargetotal"
                                            value={totalBilledAmount.toFixed(2)}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="currency"
                                            value={currency}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="txndatetime"
                                            value={txndatetime}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="hashExtended"
                                            value={payHash}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="hash_algorithm"
                                            value={hash_algorithm}
                                            readOnly
                                          />
                                          <input
                                            type="hidden"
                                            name="checkoutoption"
                                            value={checkoutoption}
                                            readOnly
                                          />

                                          <input
                                            type="hidden"
                                            name="mode"
                                            value={mode}
                                          />
                                          <input
                                            type="hidden"
                                            name="language"
                                            value={language}
                                          />
                                          <input
                                            type="hidden"
                                            name="responseFailURL"
                                            value={responseFailURL}
                                          />
                                          <input
                                            type="hidden"
                                            name="responseSuccessURL"
                                            value={responseSuccessURL}
                                          />
                                          <input
                                            type="hidden"
                                            name="customerid"
                                            value={jsontoken.user_id}
                                          />
                                          <input
                                            type="hidden"
                                            name="comments"
                                            value={
                                              'RestaurantID:' + restaurantId
                                            }
                                          />

                                          <button
                                            id={'new-place-order-btn'}
                                            type="submit"
                                            className="primary-btn d-none"
                                            value="Submit"
                                          >
                                            <span>Confirm Order </span>
                                            <span>
                                              JMD ${totalBilledAmount}
                                            </span>
                                          </button>
                                          <button
                                            id={'new-place-order-btn'}
                                            type="button"
                                            className="primary-btn"
                                            value="Button"
                                            onClick={handlePaySubmit}
                                          >
                                            <span>Confirm Order </span>
                                            <span>
                                              JMD ${totalBilledAmount}
                                            </span>
                                          </button>
                                        </fieldset>
                                      </form>
                                    </div>
                                  ) : (
                                    <button
                                      id={'place-order-btn'}
                                      className="primary-btn"
                                      onClick={initPaymentProcessByBalance}
                                    >
                                      <span>Confirm Order </span>
                                      <span>JMD ${totalBilledAmount}</span>
                                    </button>
                                  )}
                                </div>
                              </Modal.Footer>
                            </Modal> */}
                          </div>
                        ) : (
                          <div className="alert alert-danger">
                            {validDeliveryDate
                              ? 'We cannot deliver to that address'
                              : 'Please select correct delivery date'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Checkout
